module.exports = __webpack_public_path__ + "static/media/saso-tusar-QtgGYlug6Cw-unsplash.71acb553.jpg";